export const parseApprovalBranchIdsFromQuery = (branchesParam?: string | null): string[] | undefined => {
    if (typeof branchesParam !== 'string' || !branchesParam.trim()) {
        return undefined;
    }

    const branchIds = branchesParam.split(',').map(branchId => branchId.trim()).filter(Boolean);
    return branchIds.length ? branchIds : undefined;
};

export const getSogeCreateApprovalUrl = (orgUrl: string, versionId: string, documentElementCommonId: string, branchIds?: string[]) => {
    const path = `/orgs/${orgUrl}/documentation/versions/${versionId}/branches/${documentElementCommonId}/request-approval`;
    return branchIds?.length ? `${path}?branches=${branchIds.join(',')}` : path;
};
